import React from "react";
import Header from "../../components/headerWithSidebar";

export const PromoCode = () => {
  return (
    <>
      {/* <Header headerText="User Setting" /> */}
      <div className="flex items-center justify-center min-h-screen ">
        <div className="w-full max-w-sm p-6  rounded-lg ">
          <form>
            <div className="mb-4">
              <input
                type="email"
                id="email"
                placeholder="Existing Password"
                className="w-full px-4 py-2 border border-slate-300 bg-neutral-50 h-12 rounded-xl focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold"
              />
            </div>
            <div className="mb-4">
              <input
                type="password"
                id="password"
                placeholder="New Password"
                className="w-full px-4 py-2 border border-slate-300 bg-neutral-50 rounded-xl h-12 focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold"
              />
            </div>
            <div className="mb-4">
              <input
                type="password"
                id="password"
                placeholder="Confirm New Password"
                className="w-full px-4 py-2 border border-slate-300 bg-neutral-50 rounded-xl h-12 focus:ring-1 focus:ring-slate-300 focus:outline-none placeholder-gray-400 placeholder-bold"
              />
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 text-white bg-amber-800 rounded-xl h-12  focus:ring-1 focus:ring-amber-800 focus:outline-none placeholder-white placeholder-bold"
            >
              Confirm
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
